export enum ExtractionMethod {
    OCR = "ocr",
    AUDIO = "audio",
    MANUAL = "manual"
}

export enum ExtractionJobStatus {
    Submitted = 'SUBMITTED',
    Queued = 'QUEUED',
    Starting = 'STARTING',
    Running = 'RUNNING',
    Failed = 'FAILED',
    Succeeded = 'SUCCEEDED',
    Cancelled = 'CANCELLED',
}

export enum TranslationMethod {
    GOOGLE = "google",
    AI = "ai_translator"
}

export enum PaymentStatus {
    CREATED = "created",
    PENDING = "pending",
    COMPLETED = "completed",
    FAILED = "failed",
    CANCELLED = "cancelled",
    UNKNOWN = "unknown",
    REFUNDED = "refunded",
}
